import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { get } from "../../_api";
import ListElem from "../List/ListElem";
import { Button, Stack, Text } from "@mantine/core";

interface IOfferRes {
  _id: string;
  title: string;
  meta: { createdDate: string };
  main: boolean;
}

const Offers: React.FC = () => {
  const [offers, setOffers] = useState<IOfferRes[]>([]);

  useEffect(() => {
    get("offers/ids").then((res: IOfferRes[]) => setOffers(res));
  }, []);

  return (
    <Stack gap="md" maw={1200} mx="auto" px="md" pb={250}>
      <Button component={Link} to="/offers/new" size="md" radius="md" w={{ base: "100%", sm: "auto" }}>
        Dodaj ofertę
      </Button>

      <Stack gap={0}>
        {offers.length === 0 && <Text>Brak ofert</Text>}
        {offers.map((el, i) => (
          <ListElem
            id={el._id}
            key={el._id}
            order={i + 1}
            infoBig={el.title}
            infoSmall={el.main ? "Główna" : undefined}
            date={el.meta?.createdDate || new Date()}
            link={`/offers/${el._id}`}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default Offers;
